import { createContext } from 'react';
import { PagecontextProps } from './types';

export const PageContext = createContext<PagecontextProps>({} as PagecontextProps);
